import styles from "../../styles/Footer.module.css";
import googlePlay from "../../assets/play-store.png";
import appstore from "../../assets/app-store.png";
import { NavLink, Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import GlowButton from "../landing/GlowButton";
import dotPurple from "../../assets/dot.png";

const Footer = () => {

  return (
    // 👇 font-lexend added here so ALL text inside footer uses Lexend
    // Updated background to match hero carousel
    <footer className={`${styles.footer} relative font-lexend`}
      style={{
        backgroundImage: `url(${require("../../assets/background-landing-color-2.png")})`,
        backgroundSize: "cover",
        backgroundPosition: "center bottom",
        backgroundRepeat: "no-repeat"
      }}
    >

      {/* Main Layout Container */}
      <div className="relative z-10 flex flex-col lg:flex-row flex-wrap justify-between items-start px-4 sm:px-6 md:px-10 pt-[10px] gap-6 text-[20px] lg:text-[22px]">
        {/* === Left Section: Logo and Description === */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left w-full sm:w-[90%] md:w-[60%] lg:w-[35%] mx-auto md:ml-[140px] lg-xl:ml-[-3rem] xl-2xl:ml-[-4.6rem] mt-16 sm:mt-7 md:mt-7">
          <img
            src={logo}
            alt="Beemz Logo"
            className="h-8 w-auto sm:mb-[-.7rem] mb-2 xl-2xl:ml-12 lg-xl:mb-[-.4rem] xl-2xl:mb-[-.2rem]"
          />
          <p
            className={`${styles.tagline} w-full sm:w-[90%] lg:w-[800px] tracking-[0.05rem]`}
          >
            <span className="sm:text-[16px] text-[20px]">
              the out & about chat app
            </span>
          </p>

          <p className="w-full max-w-[600px] sm:max-w-[90%] lg:max-w-[500px] mt-3 tracking-[0.05rem] leading-relaxed">
            <span className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-[20px]">
              beɘmz has revolutionized restaurant and retail management since
              2022, providing commission-free ordering solutions that help small
              businesses thrive in the digital age.
            </span>
          </p>

          <div className="flex justify-center md:justify-start space-x-4 pt-4">
            <a
              href="https://play.google.com/store/apps/details?id=com.beemxyz&hl=en_IN"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={googlePlay}
                alt="Get it on Google Play"
                className="h-10 sm:h-12 md:h-14 cursor-pointer hover:scale-105 transition-transform duration-300"
              />
            </a>
            <a
              href="https://apps.apple.com/us/app/beemz/id1609866877"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={appstore}
                alt="Download on App Store"
                className="h-10 sm:h-10 md:h-12 mt-1 cursor-pointer hover:scale-105 transition-transform duration-300 rounded-lg bg-white"
              />
            </a>
          </div>
        </div>

        {/* === Middle Section: Quick Links + Follow Us === */}
        <div
          className={`${styles.links} 
  flex flex-row flex-wrap 
  justify-between 
  items-start 
  w-full sm:w-[80%] md:w-[50%] lg:w-[30%] 
  gap-10 pt-10 lg:pt-20`}
        >
          {/* Quick Links */}
          <div>
            <ul className="tracking-[0.05rem] space-y-1 leading-tight">
              <li>
                <h3 className="text-[20px] font-semibold">quick links</h3>
              </li>
              <li>
                <NavLink
                  to="/aboutus"
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#FCBA05] font-semibold transition"
                      : "hover:text-[#FCBA05] transition"
                  }
                >
                  <span className="text-[16px]">about us</span>
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  to="/faq"
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#FCBA05] font-semibold transition"
                      : "hover:text-[#FCBA05] transition"
                  }
                >
                  <span className="text-[16px]">faq</span>
                </NavLink>
              </li> */}
              <li>
                <NavLink
                  to="/pricing"
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#FCBA05] font-semibold transition"
                      : "hover:text-[#FCBA05] transition"
                  }
                >
                  <span className="text-[16px]">pricing</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/demo"
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#FCBA05] font-semibold transition"
                      : "hover:text-[#FCBA05] transition"
                  }
                >
                  <span className="text-[16px]">demo</span>
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  to="/blog"
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#FCBA05] font-semibold transition"
                      : "hover:text-[#FCBA05] transition"
                  }
                >
                  <span className="text-[16px]">blog</span>
                </NavLink>
              </li> */}
              <li>
                <NavLink
                  to="/contact"
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#FCBA05] font-semibold transition"
                      : "hover:text-[#FCBA05] transition"
                  }
                >
                  <span className="text-[16px]">contact</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/printingmaterial"
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#FCBA05] font-semibold transition"
                      : "hover:text-[#FCBA05] transition"
                  }
                >
                  <span className="text-[16px]">printing material</span>
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Follow Us */}
          {/* <div>
            <ul className="tracking-[0.05rem] space-y-1 leading-tight">
              <li>
                <h3 className=" sm:text-[20px] text-[20px]  font-semibold">
                  follow us
                </h3>
              </li>
              <li>
                <a href="#">
                  <span className="text-[16px]">beɘmz</span>
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/919999999999"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-[16px]">whatsapp</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/login/with-signed-email"
                  target="_blank"
                >
                  <span className="text-[16px]">tiktok</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/login.php"
                  target="_blank"
                >
                  <span className="text-[16px]">facebook</span>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/login" target="_blank">
                  <span className="text-[16px]">linkedin</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/accounts/login/"
                  target="_blank"
                >
                  <span className="text-[16px]">instagram</span>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/login" target="_blank">
                  <span className="text-[16px]">X</span>
                </a>
              </li>
            </ul>
          </div> */}
        </div>

        {/* === Right Section: CTA === */}
        <div className={`${styles.cta} relative z-10 flex flex-col items-center text-center md:text-left md:items-start w-full sm:w-[90%] md:w-[70%] lg:w-[25%]  mx-auto mt-10 lg:mt-[90px] lg-xl:mr-[-2.7rem]`}>
          <ul className="flex sm:justify-left md:justify-start space-x-4 mb-2 sm:mb-0">
            <li>
              <Link
                to="/contact"
                className="transition-colors text-[#6E3FC6]"
              >
                contact
              </Link>
            </li>
          </ul>

          <h2 className="text-2xl md:text-[26px] font-semibold text-white sm:mt-[-2rem]">
            ready to get started?
          </h2>

          <p className="max-w-md md:text-2xl mt-2 lowercase sm:max-w-[250px] sm:text-center">
            Transform your restaurant or retail business with beɘmz's all-in-one
            platform today. <br />
            Free, no risk 30-day trial. Cancel anytime.
          </p>

          {/* location + email */}
          <div className="pt-2 text-sm leading-snug font-normal">
            <p
              className="
                font-normal
                text-[18px] leading-[26px]
                text-[#6E3FC6]
                lowercase
                flex items-center flex-wrap gap-x-1
              "
            >
              <span>northwall</span>
              <span className="inline-flex items-center justify-center">
                <img
                  src={dotPurple}
                  alt=""
                  className="w-[8px] h-[8px] md:w-[13px] md:h-[13px]"
                />
              </span>
              <span>dublin</span>
              <span className="inline-flex items-center justify-center">
                <img
                  src={dotPurple}
                  alt=""
                  className="w-[8px] h-[8px] md:w-[13px] md:h-[13px]"
                />
              </span>
              <span>ireland</span>
            </p>
            <p className="text-gray-700 mt-1 font-normal">
              support@beɘmxyz.com
            </p>
          </div>

          <div className="mt-0 flex flex-wrap justify-center items-center gap-3">
            <button
              onClick={() => window.location.href = "/business/demo"}
                className="h-[48px] inline-flex items-center justify-center border border-[#6E3FC6] bg-[#e9d9ff] hover:bg-[#d8bfff] text-black text-sm sm:text-sm font-medium px-[30px] sm:px-[18px] rounded-full transition-all duration-300 cursor-pointer text-center"
            >
              how it works
            </button>
            <span><GlowButton btnValue="free trial" btn1="2" onClick={() => window.location.href = "/business/get-started"} /></span>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className={`${styles.footerBottom} text-center mt-10`}>
        <div>© 2025 beɘmz. all rights reserved</div>
        <div className="mt-2">a product of oCisP Limited</div>
      </div>
    </footer>
  );
};

export default Footer;
